/**
 * 与 axios request 使用同一套规则，保证 VUE_APP_BASE_API 为外网 API 时，
 * el-upload 等原生请求也指向同一后端（避免仍请求管理站子域 /api）。
 */
export function getApiBaseURL() {
  const raw = process.env.VUE_APP_BASE_API
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    return '/api'
  }
  let base = String(raw).trim().replace(/\/+$/, '')
  if (!/^https?:\/\//i.test(base)) {
    return base === '' ? '/api' : base
  }
  try {
    const u = new URL(base)
    const p = u.pathname || '/'
    if (p === '/' || p === '') {
      return `${u.origin}/api`
    }
  } catch (e) {
    /* 保持原样 */
  }
  return base
}

/** 图片上传（与 FileController /upload/image 一致，已含 context-path） */
export function getUploadImageUrl() {
  const base = getApiBaseURL().replace(/\/+$/, '')
  return `${base}/upload/image`
}
